export const getMountainTime = (date) => {
    const mountainDate = new Date(date).toLocaleTimeString('en-US', { timeZone: 'America/Denver', hour12: false });
    const mountainDay = new Date(date).toLocaleDateString('en-US', { timeZone: 'America/Denver', hour12: false });
    const day = Number(mountainDay.split('/')[1]);
    let mountainTimeHours = Number(mountainDate.split(':')[0]);
    if (mountainTimeHours === 24) {
        mountainTimeHours = 0;
    }
    const mountainTimeMinutes = Number(mountainDate.split(':')[1]);
    return {
        day,
        mountainDate,
        mountainTimeHours,
        mountainTimeMinutes
    }
}